import * as eventRoutines from './eventRoutines';
import * as ui_action from '../../redux/ui/actions';
import {connect, useDispatch, useSelector} from 'react-redux';
import {
    makeEventsList,
    selectActiveMasterEventsEF,
    selectActiveMasterEventsEFMeta

} from './selectors';
import { syncChannels } from '../Channels/channelRoutines';
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import SimpleTable from '../../Components/Atoms/SimpleTable';
import Typography from '@material-ui/core/Typography';
import getApi from '../../services/api'
import {QueryResult} from "material-table";
import * as ls from "../../services/localStorage";
import get from "lodash/get";
import {Event} from "../../models/Event";
import {EfResponseMeta} from "../../Interfaces/efData";
import getListEventsQueryParams from "../../helpers/getListEventsQueryParams";
const Events = ({ events, eventsLoaded, history, setActiveEvent, toggleEventInActiveList }: any) => {
    const dispatch = useDispatch();

    const activeMasterMeta = useSelector(selectActiveMasterEventsEFMeta)

    let formattedEFEvents = useSelector(selectActiveMasterEventsEF)

    const handleClick = (id: string) => {
        dispatch(eventRoutines.fetchEvent(id))
        setActiveEvent(id);
        history.push(`events/${id}`);
    };

    //TODO this could be moved elsewhere
    let columns = [
        { title: 'Name', field: 'name' },
        { title: 'Start time',
            field: 'startTime',
            customSort: (a:any, b:any) => {
                return a;
            }
        },
        {
            title: 'End time',
            field: 'endTime' ,
            customSort: (a:any, b:any) => {
                return a;
            }
        },
    ];


    //TODO this should only be used for EF
    //TODO this should be abstracted somewhere and cleaned up!
    const data = async (query:any): Promise<QueryResult> =>{
        let  meta: EfResponseMeta = activeMasterMeta;
        const q = {...query};
        const {pageNo, sortBy, sortDirection} = getListEventsQueryParams(q)
       return new Promise(async (resolve, reject) => {
           //Only fetch events if we don't already have this page in the store
               const res = await getApi.listEvents(ls.getCCValues().CC_USER_ID,
                   {
                       query: q.search,
                       page: pageNo,
                       resultsPerPage: q.pageSize,
                       sortBy,
                       sortDirection
                   })
               const eventResData = get(res, 'data');
               meta = get(res, 'data.meta');
               dispatch(eventRoutines.fetchEvents.success({...eventResData, query:q.search}))
               formattedEFEvents = eventResData.data.map((obj: any) => Event.fromApiResponse(obj))

            resolve({
                data: formattedEFEvents,
                page:meta.currentPage - 1,
                totalCount:meta.totalResults
            })
        })
    };
    return (
        <React.Fragment>
            <Typography component="h1" style={{ color: '#666', textAlign: 'left', padding: '25px 0 ' }} variant="h4">
                Active Events
            </Typography>
            {!eventsLoaded || !events ? (
                <CircularProgress />
            ) : (
                <SimpleTable
                    actions={[]}
                    columns={columns}
                    data={data}
                    id="Events-master"
                    onRowClick={(event: any, rowData: any) => {
                        handleClick(rowData.id);
                    }}

                    options={{ pageSize: 10  }}
                />
            )}
        </React.Fragment>
    );
};

function mapStateToProps(state: any) {
    return { events: makeEventsList(state), eventsLoaded: state.ui.eventsLoaded };
}

const mapDispatchToProps = {
    setActiveEvent: ui_action.setActiveEvent,
    syncChannels,
    toggleEventInActiveList: eventRoutines.togglePresenceOfEventInActiveEventsList,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Events));
